module.exports = __webpack_public_path__ + "img/hint.1736aa00.png";